import { timeZoneCode } from '@/constants/global';
import { changeStartEndStringTimeZone, injectSeparatorDateString } from '@/utils';
// eslint-disable-next-line import/prefer-default-export
export const editWorkerFormData = (workerDetail) => {
    const injectSeparatorWorkerRegDate = injectSeparatorDateString(workerDetail.workerRegDate);
    const injectSeparatorWorkerLeaveDate = injectSeparatorDateString(workerDetail.workerLeaveDate);
    const krTimeString = changeStartEndStringTimeZone(workerDetail.workTime, timeZoneCode.KR);
    const workTimeOn = krTimeString.slice(0, 4);
    const injectSeparatorOn = [
        workTimeOn.slice(0, 2),
        workTimeOn.slice(2, 4),
    ].join(':');
    const workTimeOff = krTimeString.slice(4, 8);
    const injectSeparatorOff = [
        workTimeOff.slice(0, 2),
        workTimeOff.slice(2, 4),
    ].join(':');
    return {
        // 허브 아이디
        hubId: workerDetail.hubId,
        // 라이더명
        name: workerDetail.name,
        // 사번
        hubEmployeeNumber: workerDetail.hubEmployeeNumber,
        // 고용형태
        employeeType: workerDetail.employeeType,
        // 보수지급방식
        salaryType: workerDetail.salaryType,
        // 대체연락처
        telNumber: workerDetail.telNumber,
        // 라이더 상태
        useYn: workerDetail.useYn,
        // 근무시간
        workTime: {
            on: injectSeparatorOn,
            off: injectSeparatorOff,
        },
        // 주소
        homeAddress: workerDetail.homeAddress,
        // 라이더 유형
        type: workerDetail.type,
        // 입사일
        workerRegDate: injectSeparatorWorkerRegDate,
        // 퇴사일
        workerLeaveDate: injectSeparatorWorkerLeaveDate,
        // 관리자 메모
        memo: workerDetail.memo,
        // 예치금
        depositBaromoney: workerDetail.depositBaromoney,
        // 결격여부
        convictionStatus: workerDetail.convictionStatus,
    };
};
